import { createFileRoute } from "@tanstack/react-router";

import DevBoard from "../pages/DevBoard";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/dev-board")({
  component: DevBoardRoute,
});

function DevBoardRoute() {
  return (
    <RequireAuth require="adminOrLimitedAdmin">
      <DevBoard />
    </RequireAuth>
  );
}
